/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusGraphicDto
 */
export interface NovitusGraphicDto {
    /**
     * ID grafiki (0-1023)
     * @type {number}
     * @memberof NovitusGraphicDto
     */
    number: number;
}

/**
 * Check if a given object implements the NovitusGraphicDto interface.
 */
export function instanceOfNovitusGraphicDto(value: object): value is NovitusGraphicDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function NovitusGraphicDtoFromJSON(json: any): NovitusGraphicDto {
    return NovitusGraphicDtoFromJSONTyped(json, false);
}

export function NovitusGraphicDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusGraphicDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
    };
}

export function NovitusGraphicDtoToJSON(value?: NovitusGraphicDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
    };
}

